export const KINDS = ["weapon", "tool", "item", "food", "armor", "mob"] as const;
export type Kind = (typeof KINDS)[number];

export const RARITIES = ["common", "uncommon", "rare", "epic"] as const;
export type Rarity = (typeof RARITIES)[number];

export interface TimedEffect {
  effect: string;
  seconds: number;
  level: number;
}

export type HitPower =
  | { type: "effect"; effect: string; seconds: number; level: number }
  | { type: "self_effect"; effect: string; seconds: number; level: number }
  | { type: "ignite"; seconds: number }
  | { type: "lightning" }
  | { type: "extra_damage"; amount: number };

export type Ability =
  | { type: "buff"; effects: TimedEffect[] }
  | { type: "heal"; power: number }
  | { type: "leap"; power: number }
  | { type: "blink"; distance: number }
  | { type: "lightning"; distance: number }
  | { type: "meteor"; distance: number; power: number }
  | { type: "shockwave"; radius: number; damage: number }
  | { type: "summon_allies"; mob: string; count: number };

export interface Stats {
  attackDamage?: number;
  attackSpeed?: number;
  armor?: number;
  armorToughness?: number;
  moveSpeed?: number;
  maxHealth?: number;
  durability?: number;
}

export interface Food {
  nutrition: number;
  saturation: number;
  effects: TimedEffect[];
}

export interface Mob {
  entity: string;
  health: number;
  scale: number;
  damage: number;
  speedLevel: number;
  glowing: boolean;
  mainhand: string | null;
  effects: TimedEffect[];
}

export interface Recipe {
  pattern: string[];
  key: Record<string, string>;
}

export interface Creation {
  id: string;
  kind: Kind;
  name: string;
  description: string;
  baseItem: string;
  rarity: Rarity;
  glint: boolean;
  stats: Stats;
  hitPowers: HitPower[];
  ability: Ability | null;
  cooldownSeconds: number;
  food: Food | null;
  mob: Mob | null;
  recipe: Recipe | null;
  texturePrompt: string;
}
